import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, " The screen displays a record of payments you have made towards Plan C coverage ")
  ])
], -1)
const _hoisted_2 = { class: "contributions-tables cobra-payments" }
const _hoisted_3 = { class: "contributions-table-wrapper" }
const _hoisted_4 = { class: "contributions-table-item no-striped" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Payment Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Ref #"),
    /*#__PURE__*/_createElementVNode("th", null, "Check / Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Source")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "No statements found.")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-center justify-content-md-end mt-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", null, [
            _hoisted_5,
            ($setup.dataLoaded && $setup.paymentDetails.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentDetails, (detail, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(detail.PaymentDate), 1),
                      _createElementVNode("td", null, _toDisplayString(detail.ReceiptDate), 1),
                      _createElementVNode("td", null, _toDisplayString(detail.PaymentRef), 1),
                      _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(detail.Amount)), 1),
                      _createElementVNode("td", null, _toDisplayString(detail.Source), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_7, _hoisted_9))
          ]),
          _hoisted_10
        ])
      ])
    ])
  ], 64))
}